var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestartPhaseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5924 6.20354V3.33008",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4662 3.33073H12.5928",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.835 3.9082C15.7265 5.27856 17.2456 8.50209 16.4619 11.6044C15.6782 14.7067 12.8104 16.822 9.61501 16.6547C6.41962 16.4873 3.78842 14.0841 3.33301 10.9169",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88314 3.33078C8.88311 3.35378 8.86446 3.3724 8.84146 3.3724C8.81846 3.37239 8.79982 3.35375 8.7998 3.33075C8.79979 3.30775 8.81842 3.28909 8.84141 3.28906C8.85248 3.28905 8.8631 3.29344 8.87093 3.30126C8.87876 3.30909 8.88315 3.31971 8.88314 3.33078",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91927 4.44113C5.91924 4.46413 5.90059 4.48276 5.87759 4.48275C5.85459 4.48274 5.83595 4.4641 5.83594 4.4411C5.83593 4.4181 5.85456 4.39944 5.87755 4.39941C5.88862 4.3994 5.89924 4.40379 5.90707 4.41162C5.91489 4.41944 5.91928 4.43006 5.91927 4.44113",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70833 7.03391C3.7083 7.05691 3.68964 7.07553 3.66664 7.07552C3.64365 7.07551 3.62501 7.05687 3.625 7.03387C3.62499 7.01087 3.64362 6.99222 3.66662 6.99219C3.67769 6.99217 3.68831 6.99657 3.69613 7.00439C3.70396 7.01222 3.70835 7.02284 3.70833 7.03391",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartPhaseBtn);
export default __webpack_public_path__ + "static/media/restartPhaseBtn.8c2746c5dd340ea25b0d5efd9ef9d49e.svg";
export { ForwardRef as ReactComponent };